import { reactive } from "vue";
import { api } from "../api.js";

var defaults = {
	loading: false,
	error: null,
	hours: 24,
	samples: [],
	decisions: [],
	lastFetched: null,
};

var historyStore = {
	data: reactive({ ...defaults }),
	methods: {
		load: async function (hours) {
			historyStore.data.loading = true;
			if (hours != null) { historyStore.data.hours = hours; }
			try {
				var [samplesRes, decisionsRes] = await Promise.all([
					api.get("/api/history?hours=" + historyStore.data.hours),
					api.get("/api/decisions?limit=200"),
				]);
				historyStore.data.samples = samplesRes.samples ?? [];
				historyStore.data.decisions = decisionsRes ?? [];
				historyStore.data.lastFetched = Date.now();
				historyStore.data.error = null;
			} catch (e) {
				historyStore.data.error = e.message;
			} finally {
				historyStore.data.loading = false;
			}
		},
		clearStore: function () {
			Object.assign(historyStore.data, defaults);
		},
	},
};

export default historyStore;
